'use client'

import { FC, useEffect } from "react";
import { Container } from "./styled";
import { Loader } from "@/components";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";

export const CallbackScreen: FC = () => {
  const { status } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (status === 'authenticated') {
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get('redirect') || '/';
      router.replace(redirect);
    }
  }, [status, router]);

  return (
    <Container>
      <Loader />
    </Container>
  );
};
